<div *ngIf="enabled && !loading && (pagination.totalPages > 1) && (pagination.page < pagination.totalPages)"
     inViewport (inViewportAction)="onInViewportChange($event)"></div>

<div *ngIf="false" class="pagination" [class.active]="enabled && !loading && pagination.totalPages > 1 && pagination.page >= pagination.totalPages">
  {{ nothingMoreText | translate }}
</div>

<a class="pagination-pager"
   [class.visible]="enabled && loading && (pagination.page < pagination.totalPages)"
   (click)="goNextPage($event)"
   [attr.href]="baseUrl + '?page=' + (pagination?.page + 1)">
  <circle-to-square-spinner></circle-to-square-spinner>
</a>
<pre *ngIf="false">
  enabled: {{ enabled | json }}
  loading: {{ loading | json }}
  pagination: {{ pagination | json }}
</pre>
